import styles from "./SearchBar.module.scss";
import { useTranslation } from "react-i18next";

const SearchBar = ({ search = "", setSearch = () => {}, onSubmit, page, setPage, placeholder }) => {
    const { t } = useTranslation();

    return (
        <form className={styles.form} onSubmit={onSubmit}>
            <input
                type="text"
                placeholder={t(placeholder)}
                value={search}
                onChange={(e) => {
                    setSearch(e.target.value);
                    setPage(1);
                }}
            />
            {/*<button type="submit" className={styles.button}>*/}
            {/*    <img src={searchImg} alt="search" />*/}
            {/*</button>*/}
        </form>
    );
};

export default SearchBar;
